import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  CustomButton,
  CustomButtonWithBorder,
  CustomButtonWithOutLoader,
} from "./CustomButton";

export const ConfirmationDialog = ({
  open,
  onClose,
  title = "Confirm Action",
  message = "Are you sure you want to continue?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  children,
  showChildren = false,
  handledisabled = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          width: 650,
          maxWidth: "100%",
          borderRadius: 2,
          overflow: "visible",
        },
      }}
      disableScrollLock={true}
    >
      <DialogTitle id="alert-dialog-title">
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {showChildren ? (
            <DialogContentText>{children}</DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description">
              {message}
            </DialogContentText>
          )}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ mr: 2, mb: 1 }}>
        <CustomButtonWithBorder
          actionName={cancelText}
          actionFuntion={onClose}
        />
        {confirmText === "Delete" ||
        confirmText === "Deactivate" ||
        confirmText === "Reject" ||
        confirmText === "Confirm" ||
        confirmText === "Ok" ? (
          <CustomButtonWithBorder
            actionName={confirmText}
            actionFuntion={onConfirm}
            handleColor={true}
          />
        ) : (
          <>
            {handledisabled ? (
              <CustomButtonWithOutLoader
                actionName={confirmText}
                actionFuntion={onConfirm}
                disableAction={true}
              />
            ) : (
              <CustomButton
                actionName={confirmText}
                actionFuntion={onConfirm}
              />
            )}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
